import { render, staticRenderFns } from "./PdfFileView.vue?vue&type=template&id=1078265b&scoped=true&"
import script from "./PdfFileView.vue?vue&type=script&lang=js&"
export * from "./PdfFileView.vue?vue&type=script&lang=js&"
import style0 from "./PdfFileView.vue?vue&type=style&index=0&id=1078265b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078265b",
  null
  
)

export default component.exports